import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fedae00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lm-modal" }
const _hoisted_2 = { class: "lm-modal-inner" }
const _hoisted_3 = { class: "lm-modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "lm-modal-header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-2 fas fa-times cursor-pointer" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "lm-modal-body" }
const _hoisted_8 = { class: "lm-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, { name: "drop-in" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.showHeader)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "header", {}, undefined, true),
                      (_ctx.showCloseButton)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "close-icon",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                          }, _hoisted_6))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "body", {}, undefined, true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                ])
              ])
            ], 512), [
              [_vShow, _ctx.open]
            ])
          ]),
          _: 3
        })
      ], 512), [
        [_vShow, _ctx.open]
      ])
    ]),
    _: 3
  }))
}